/**
 * 关系消息记录
 * */
import React, { Component } from 'react';
import { withRouter } from '../WithRouterHOC';
import Scrollbar from 'react-scrollbars-custom';
import { Modal, message } from 'antd';
import HTTP from '../../script/service';
import { connect } from 'react-redux';
import './common.scss';
import { DDLoading } from '../globalPageStatus';
import Util from '../../script/util';
import { _change_affinity_modal } from '../../../src/store/Action';
import iconAffinityListEmptyPNG from './img/affinity-list-empty.png';

class AffinityMsg extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      loading: false,
      list: [],
      isMore: true,
      tab: 1,
      page: 1,
      size: 10,
    };
  }

  showModal = () => {
    this.setState(
      {
        visible: true,
        list: [],
      },
      () => {
        this.getAffinityList();
      }
    );
  };
  hideModal = () => {
    this.setState({
      visible: false,
    });
  };
  onChangeTab = (tab) => {
    this.setState(
      {
        page: 1,
        list: [],
        tab,
      },
      () => {
        this.getAffinityList();
      }
    );
  };

  //获取关系列表
  getAffinityList = (page = this.state.page) => {
    const { tab, size, list } = this.state;
    let params = {
      type: tab - 1,
      page,
      size,
    };
    HTTP._get_affinity_invite_page(params).then((res) => {
      if (res.code == 200) {
        let data = res.data?.list || [];

        if (data?.length < size) {
          this.setState({ isMore: false });
        } else {
          this.setState({ isMore: true });
        }
        if (page != 1) {
          data = [...list, ...data];
        }
        this.setState({ list: data, page });
      } else {
        message.error(res.message);
      }
    });
  };
  onScroll = (e) => {
    const { page, isMore } = this.state;
    if (!isMore) return;
    if (e.scrollTop == e.contentScrollHeight - e.clientHeight) {
      this.getAffinityList(page + 1);
    }
  };

  seeDetail = (item) => {
    const { tab } = this.state;
    _change_affinity_modal({
      affinityApplyModal: true,
      affinityApplyOtherUid: item.otherUid,
      affinityApplyOrderNo: item.inviteOrderNo,
      affinityApplyType: tab - 1,
    });
  };

  render() {
    const { loading, tab, list, visible, isMore } = this.state;
    return (
      <div className="affinity-modal">
        <Modal
          open={visible}
          wrapClassName="daidai-modal-style has-top-border"
          centered={true}
          title={`新的关系`}
          zIndex={1002}
          footer={null}
          keyboard={false}
          maskClosable={false}
          width="512px"
          onCancel={this.hideModal}
        >
          <DDLoading status={loading} className="set-plan-spin">
            <div className="affinity-modal-box">
              <div className="affinity-tab">
                <div
                  className={`affinity-tab-item ${tab == 1 ? 'active' : ''}`}
                  onClick={() => this.onChangeTab(1)}
                >
                  收到邀请
                </div>
                <div
                  className={`affinity-tab-item ${tab == 2 ? 'active' : ''}`}
                  onClick={() => this.onChangeTab(2)}
                >
                  发出邀请
                </div>
              </div>
              <Scrollbar
                ref={(el) => (this.scrollElement = el)}
                className="my-scroll-bar"
                style={{ height: '620px' }}
                onScroll={this.onScroll}
              >
                {list.length > 0 ? (
                  <div className="affinity-table">
                    {list.map((item) => (
                      <div
                        key={item.inviteOrderNo}
                        className="affinity-table-item"
                      >
                        <div className="affinity-table-left">
                          <div className="affinity-table-avatar">
                            <img
                              src={Util.transImgUrlToGame(
                                item.otherAvatar,
                                '50x50'
                              )}
                              alt=""
                            />
                          </div>
                          <div className="affinity-table-info">
                            <div className="affinity-table-name">
                              {item.otherNickName}
                            </div>
                            <div className="affinity-table-value">
                              {tab == 1 ? (
                                <p>
                                  申请和你成为
                                  {item?.relationConfig?.relationConfigName}
                                </p>
                              ) : (
                                <p>
                                  你申请和TA成为
                                  {item?.relationConfig?.relationConfigName}
                                </p>
                              )}
                            </div>
                            <div className="affinity-table-value">
                              <p>{item?.updateTimeStr}</p>
                            </div>
                          </div>
                        </div>
                        <div className="affinity-table-right">
                          {/** status 0:邀请中 10:已同意 20:已拒绝  30:已失效 40:待邀请*/}
                          {item.status == 0 && (
                            <div
                              className="affinity-table-btn btn-4"
                              onClick={() => this.seeDetail(item)}
                            >
                              查看
                            </div>
                          )}
                          {item.status == 10 && (
                            <div className="affinity-table-btn btn-5">
                              已同意
                            </div>
                          )}
                          {item.status == 20 && (
                            <div className="affinity-table-btn btn-6">
                              已拒绝
                            </div>
                          )}
                          {item.status == 30 && (
                            <div className="affinity-table-btn btn-6">
                              已失效
                            </div>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="affinity-empty">
                    <img src={iconAffinityListEmptyPNG} alt="空" />
                    {tab == 1 ? <p>暂无收到邀请</p> : <p>暂无发出邀请</p>}
                  </div>
                )}
                {!isMore && list.length > 0 && (
                  <div className="page-more">没有更多了</div>
                )}
              </Scrollbar>
            </div>
          </DDLoading>
        </Modal>
      </div>
    );
  }
}

export default connect((store) => ({ base: store }))(
  withRouter(AffinityMsg, { withRef: true })
);
